import { Typography } from '@mui/material';
import useIsUserPendingApproval from 'src/logic/hooks/auth/use-is-user-pending-approval';
import useCanModifyCatalogue from 'src/logic/hooks/smart/catalogue/use-can-modify-catalogue';
import AddNewPrivateItemLink from '../../shared/Add-private-item-link';

type IProps = {
  text?: string;
  children?: React.ReactNode;
  hideQuestion?: boolean;
  minHeight?: string;
};

const EmptySection = ({ text = 'No Results Found', children, hideQuestion, minHeight = '175px' }: IProps) => {
  const isUserPendingApproval = useIsUserPendingApproval();
  const canModifyCatalogue = useCanModifyCatalogue() && !isUserPendingApproval;

  return (
    <div
      style={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        flexDirection: 'column',
        gap: '1rem',
        minHeight,
      }}
    >
      <img src='/assets/images/no-results.png' alt='Empty' width={80} height={80} style={{ objectFit: 'contain' }} />
      <Typography color='#3A3E50' fontWeight={700} fontSize={21} textAlign={'center'}>
        {text}
      </Typography>
      {!hideQuestion && (children || (canModifyCatalogue && <AddNewPrivateItemLink />))}
    </div>
  );
};

export default EmptySection;
